let userLang = JSON.parse(window.localStorage.getItem("userLangDetail"));
export const getLocalStorage = () => {
  userLang = JSON.parse(window.localStorage.getItem("userLangDetail"));
  AdminHeaderData = {
    columns: [
      {
        label: userLang?.masters?.FREIGHT_CODE ?? "Freight Code",
        field: "freightCode",
        sort: "asc",
        width: 100,
      },
  
      {
        label: userLang?.masters?.COST_MAIN ?? "Cost Main",
        field: "costMain",
        sort: "asc",
        width: 100,
      },
      {
        label: userLang?.masters?.SOURCE ?? "Source",
        field: "source",
        sort: "asc",
        width: 100,
      },
      {
        label: userLang?.masters?.DESTINATION ??  "Destination",
        field: "destination",
        sort: "asc",
        width: 100,
      },
      {
        label: userLang?.masters?.ROUTES ??  "Route",
        field: "route",
        sort: "asc",
        width: 100,
      },
      {
        label: userLang?.masters?.TRANSPORTER ?? "Transporter",
        field: "transporter",
        sort: "asc",
        width: 100,
      },
      {
        label: userLang?.masters?.VEHICLE_TYPE ?? "VehicleType",
        field: "vehicleType",
        sort: "asc",
        width: 100,
      },
      {
        label: userLang?.masters?.VALIDITY ?? "Validity",
        field: "validityFromTo",
        sort: "asc",
        width: 100,
      },
    ],
  };
};
if (localStorage.getItem("userLangDetail") === null) {
  getLocalStorage();
}
export var AdminHeaderData = {
  columns: [
    {
      label: userLang?.masters?.FREIGHT_CODE ?? "Freight Code",
      field: "freightCode",
      sort: "asc",
      width: 100,
    },

    {
      label: userLang?.masters?.COST_MAIN ?? "Cost Main",
      field: "costMain",
      sort: "asc",
      width: 100,
    },
    {
      label: userLang?.masters?.SOURCE ?? "Source",
      field: "source",
      sort: "asc",
      width: 100,
    },
    {
      label: userLang?.masters?.DESTINATION ??  "Destination",
      field: "destination",
      sort: "asc",
      width: 100,
    },
    {
      label: userLang?.masters?.ROUTES ??  "Route",
      field: "route",
      sort: "asc",
      width: 100,
    },
    {
      label: userLang?.masters?.TRANSPORTER ?? "Transporter",
      field: "transporter",
      sort: "asc",
      width: 100,
    },
    {
      label: userLang?.masters?.VEHICLE_TYPE ?? "VehicleType",
      field: "vehicleType",
      sort: "asc",
      width: 100,
    },
    {
      label: userLang?.masters?.VALIDITY ?? "Validity",
      field: "validityFromTo",
      sort: "asc",
      width: 100,
    },
  ],
};
export const searchBar = {
  searchBarData: [
    {},
  ],
};
